import { FC, useContext, useState } from 'react';
import { ERoutes } from '../../util/constants';
import API from '../../api/api';
import Card from '../Card/Card';
import GlobalContext from '../../contexts/GlobalContext';
import styles from './MultiFactorAuthVerify.module.scss';
import common from '../../util/scss/common.module.scss';
import { MultiFactorAuthContext, EMultiFactorAuthUiState } from '../../contexts/MultiFactorAuthContext';
import CoBranding from '../CoBranding/CoBranding';
import { LoadingButton } from '@mui/lab';
import { Alert, Box, Typography, Link, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import PageLayout from '../../layout/PageLayout/PageLayout';

enum EFormFields {
    verificationCode = 'verificationCode',
}

const MultiFactorAuthVerify: FC = () => {
    const { language, coBranding } = useContext(GlobalContext);
    const { multiFactorAuthUiState, submitVerificationCode, errorMessage } = useContext(MultiFactorAuthContext);
    const [verificationCode, setVerificationCode] = useState('');

    const handleSubmitCode = (event: React.SyntheticEvent) => {
        event.preventDefault();
        submitVerificationCode(verificationCode);
    };

    return (
        <PageLayout>
            <Card>
                {(coBranding.logoUrl || coBranding.name) && (
                    <CoBranding logoUrl={coBranding.logoUrl} name={coBranding.name} />
                )}
                <header>
                    <h1 className={`${common.pageHeader} ${common.withSubhead}`}>{language.multiFactorAuth.header}</h1>
                    <label className={`${styles.label} ${common.pageSubhead}`} htmlFor={EFormFields.verificationCode}>
                        {language.multiFactorAuth.desc}
                    </label>
                </header>
                {multiFactorAuthUiState === EMultiFactorAuthUiState.error && (
                    <Alert severity="error" sx={{ mb: 2 }} data-testid="login-error">
                        {errorMessage}
                    </Alert>
                )}

                <main className={styles.verifyForm}>
                    <form data-testid="verify-form">
                        <section className={styles.verificationCode}>
                            <input
                                type="text"
                                value={verificationCode}
                                onChange={(event) => {
                                    setVerificationCode(event.target.value);
                                }}
                                spellCheck={false}
                                autoFocus={true}
                                id={EFormFields.verificationCode}
                                data-testid="verification-code"
                            ></input>
                        </section>
                        <section className={styles.formCTA}>
                            <LoadingButton
                                variant="contained"
                                type="submit"
                                onClick={handleSubmitCode}
                                loading={multiFactorAuthUiState === EMultiFactorAuthUiState.loading}
                                disabled={multiFactorAuthUiState === EMultiFactorAuthUiState.loading}
                                className={common.buttonShim}
                            >
                                {language.multiFactorAuth.verifyCta}
                            </LoadingButton>
                        </section>
                    </form>
                </main>
                <Box sx={{ textAlign: 'center', pb: 2 }}>
                    <Typography variant="body2">
                        {language.multiFactorAuth.troubleshooting.header}&nbsp;
                        <Link
                            component={RouterLink}
                            to={ERoutes.multiFactorAuthRecovery}
                            onClick={() => {
                                API.post.trackEvent({
                                    event: 'Multi-Factor Authentication | Button - Use recovery Code',
                                });
                            }}
                        >
                            {language.multiFactorAuth.troubleshooting.optionOne}
                        </Link>
                    </Typography>
                </Box>
            </Card>
        </PageLayout>
    );
};

export default MultiFactorAuthVerify;
